import { render, staticRenderFns } from "./TimelineKey.vue?vue&type=template&id=ddd52074&scoped=true"
import script from "./TimelineKey.vue?vue&type=script&lang=ts"
export * from "./TimelineKey.vue?vue&type=script&lang=ts"
import style0 from "./TimelineKey.vue?vue&type=style&index=0&id=ddd52074&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd52074",
  null
  
)

export default component.exports